export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ModalNuovaTratta.vue?vue&type=template&id=4a4e6d40&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/ModalNuovaTratta.vue?vue&type=template&id=4a4e6d40&
// module id = 843
// module chunks = 0